import { module, bootstrap } from "angular";
// import sportIconDirective from "../../partials/sport-icon/sport-icon.directive";
// import teamIconDirective from "../../partials/icons/team-icon/team-icon.directive";
// import { MatchService } from "../../services/match.service";
import { SportDataService } from "../../services/sport-data.service";
import { addGTMTag, generalConfig, /*rollbarConfig*/ } from "../general";
import "./single-offer-banner.scss";
// import flagIconDirective from "../../partials/icons/flag-icon/flag-icon.directive";
import { nthFilter } from "../../filters/nth.filter";
import { GeneralService } from "../../services/general.service";
// import { BetService } from "../../services/bet.service";
import { BlockConfigurationObject } from "../../interfaces/block-configuration-object.interface";
import singleOfferBannerComponents from "./single-offer-banner.components";

function loadSingleSiOfferBanner(config: BlockConfigurationObject): Promise<void> {
	return new Promise((resolve, reject) => {
		if (config.matchID) {
			// remove case-sensitivity for match ID
			config.matchID = config.matchID.toUpperCase();
		}
		// determine target element
		if (!config.targetElementID) {
			config.targetElementID = "si-external-single-offer-banner";
		}
		const targetElement = document.getElementById(config.targetElementID);
		if (targetElement !== null) {
			if (config.debugMode) {
				targetElement.innerHTML = "Loading Single Offer Banner Block...";
			}
	
			if (config.publicationTheme) {
				
				require("../../publisher-themes/" + config.publicationTheme + ".scss");
			}

			targetElement.innerHTML = "<si-external-single-offer-banner></si-external-single-offer-banner>";

			addGTMTag(config);

			module("siExternalSingleOfferBanner", [require("angular-sanitize"), /* 'ngAnimate',*/ /*require("ng-rollbar")*/])
				.value("configurationObject", config)
				.value("apiDomain", process.env.API_DOMAIN)
				.constant("blockDomain", process.env.BLOCK_DOMAIN)
				.constant("cdnDomain", process.env.CDN_DOMAIN)
				.filter("nth", nthFilter)
				.service("generalService", GeneralService)
				// .service("matchService", MatchService)
				.service("sportDataService", SportDataService)
				// .service("betService", BetService)
				// .directive("teamIconSport", teamIconDirective)
				// .directive("flagIconCountry", flagIconDirective)
				// .directive("sportIconCode", sportIconDirective)
				.config(generalConfig)
				.component("siExternalSingleOfferBanner", singleOfferBannerComponents)
				// .config(["RollbarProvider", rollbarConfig]);

			bootstrap(targetElement, ["siExternalSingleOfferBanner"], {strictDi: true});

			resolve();

		} else {
			reject(`Target element (#${config.targetElementID}) not found`);
		}
	});
}

function loadSiOfferBanner(config: BlockConfigurationObject): Promise<void> {
	return new Promise((resolve, reject) => {
		console.log("SI Loader script called");
		if (config) {
			if (Array.isArray(config)) {
				config.reduce((previousPromise, nextConfig) => {
					return previousPromise.then(() => {
						return loadSingleSiOfferBanner(nextConfig);
					}, (err) => {
						console.error("Single Offer Banner Block failed: " + err);
						return loadSingleSiOfferBanner(nextConfig);
					});
				}, Promise.resolve()).then(resolve);
			} else {
				loadSingleSiOfferBanner(config).then(() => {
					console.log("Single Offer Banner Block Successfully Loaded");
					resolve();
				}, (err) => {
					console.log(`Single Offer Banner Block failed: ${err}`);
					reject(`Single Offer Banner Block failed: ${err}`);
				});
			}
		} else {
			console.log("Configuration object (config) not found");
			reject("Configuration object (config) not found");
		}
	});
}

if (typeof window !== undefined) {
	window["loadSiOfferBanner"] = loadSiOfferBanner;
}
export { loadSiOfferBanner as loadSiOfferBanner };